import { render, staticRenderFns } from "./HostelEdit.vue?vue&type=template&id=098c2d1f"
import script from "../../controllers/hostel/hostel-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/hostel/hostel-edit.js?vue&type=script&lang=js&external"
import style0 from "./HostelEdit.vue?vue&type=style&index=0&id=098c2d1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports